import store from '@/store'
import session from '@/auth/session'
import auth from '@/auth'
import axios from 'axios'
import { createAuthRequest } from '@/auth/token'
import { supportAuthorizationRefreshService } from '@/auth/support'

/**
 * Callback executed after any valid request
 * @param   {*} response  Returned by service
 * @return  {*} Response obtained
 */
const onResponse = (response) => {
  store.dispatch('errors/empty')
  return response
}

/**
 * Callback executed after any invalid request
 * @param   {*} error Returned by service
 * @return  {Promise|void|*} Promise rejection
 */
const onError = (error) => {
  if (error.code === 'ECONNABORTED') {
    return timeOutError(error)
  }
  if (error.request.status < 400) {
    return Promise.reject(error)
  } else if (error.request.status === 403 || error.request.status === 401) {
    let originalRequest = error.config
    if (session.isApiLogin()) {
      if (session.isSupportSession()) {
        return resfreshTokenBySupportApiLogin(originalRequest)
      } else {
        return refreshTokenByApiLogin(originalRequest)
      }
    } else {
      return refreshTokenByCookie(originalRequest)
    }
  } else if (error.request.status === 404) {
    return Promise.reject(error)
  } else {
    return throwError(error)
  }
}

/**
 * Stores a timeout error
 * @param {*} error Obtained from service
 */
function timeOutError(error) {
  store.dispatch('errors/empty').then(() => {
    store.dispatch('errors/addServerError', error)
    return Promise.reject(error)
  })
}

/**
 * Forces a token refresh if coming from support mode
 * @param   {*} originalRequest Original request
 * @return  {Promise} New request
 */
function resfreshTokenBySupportApiLogin(originalRequest) {
  return supportAuthorizationRefreshService().then(result => {
    originalRequest.headers['token'] = 'Bearer ' + result.access_token
    return axios(originalRequest)
  }, () => {
    store.dispatch('errors/empty').then(() => {
      store.dispatch('errors/addExpirationError')
    })
  })
}

/**
 * Refresh session token
 * @param   {*} originalRequest Original request
 * @return  {Promise} New request
 */
function refreshTokenByApiLogin(originalRequest) {
  return auth.refreshAuthenticateNew()
    .then(result => {
      if (originalRequest.headers.Authorization) {
        originalRequest.headers['Authorization'] = 'Bearer ' + result.access_token
        return axios(originalRequest)
      }
      originalRequest.headers['token'] = 'Bearer ' + result.access_token
      return axios(originalRequest)
    }, () => {
      store.dispatch('errors/empty').then(() => {
        store.dispatch('errors/addExpirationError')
      })
    })
}

/**
 * Refresh token with cookie
 * @param   {*} originalRequest Original request
 * @return  {Promise} New request
 */
function refreshTokenByCookie(originalRequest) {
  let { authorization, options } = createAuthRequest()
  return auth.authenticate(authorization, options)
    .then(result => {
      originalRequest.headers['token'] = result.data.token
      return axios(originalRequest)
    }).catch(error => {
      return Promise.reject(error)
    })
}

/**
 * Dispatch a new error into store status
 * @param   {*} error Obtained from service
 * @return  {Promise} Promise rejection
 */
function throwError(error) {
  let msg = error.response.data.description
  let code = error.response.data.code
  if (code) msg = `${msg} (Código de error: ${code})`
  store.dispatch('errors/addServerError', { msg })
  return Promise.reject(error)
}

export default {
  onResponse,
  onError
}
